module Meevo.Plugins.Egifts {
    import LocationSearchCriteria = Meevo.Model.LocationSearchCriteria;
    import ILocationListItemBase = Meevo.Model.ILocationListItemBase;
    import MerchantAccount = Meevo.Model.MerchantAccount;
    import StorageTypeEnum = Meevo.Model.StorageTypeEnum;
    import IStorageFile = Meevo.Model.IStorageFile;
    import MerchantProvider = Meevo.Model.MerchantProvider;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import EgfitCommunicationTypeEnum = Meevo.Plugins.Egifts.EgfitCommunicationTypeEnum;
    import IEGiftsSettings = Meevo.Model.IEGiftsSettings;
    import ICustomBranding = Meevo.Model.ICustomBranding;
    import NotificationItemTypeEnum = Meevo.Plugins.Egifts.EgiftNotificationsSection.NotificationItemTypeEnum
    import GiftCardType = Meevo.Model.GiftCardType;

    interface IEgiftsService {
        getMerchantAccounts(request: EgiftMainSection.IGetMerchantAccountsReq): angular.IPromise<Array<MerchantAccount>>;
        getLocation(locationId: number): angular.IPromise<EgiftMainSection.IEgiftLocationItem>;
        updatePackages(packageList: Array<EgiftPackedgeSection.ISelectedPackage>): angular.IPromise<EgiftPackedgeSection.ISelectedPackage>;
        updateServices(serviceList: Array<EgiftServicesSection.ISelectedService>): angular.IPromise<EgiftServicesSection.ISelectedService>;
        updateDiscounts(discountsList: EgiftPromotionsSection.ISelectedDiscounts): angular.IPromise<any>;
        getTemplates(request: EgiftTemplates.IBaseTemplateReq, isCardTemplateSection: boolean): angular.IPromise<Array<ITemplateItem>>;
        createTemplate(newTemplate: ITemplateItem, isCardTemplateSection: boolean): angular.IPromise<ITemplateItem>;
        updateTemplates(templatesList, templateType: EGiftTemplateType): angular.IPromise<void>;
        addNewPromo(promo: EgiftPromotionsSection.IEgiftDiscount): angular.IPromise<EgiftPromotionsSection.IDiscount>;
        editPromo(promo: EgiftPromotionsSection.IEgiftDiscount): angular.IPromise<EgiftPromotionsSection.IDiscount>;
        getPromo(id: Guid): angular.IPromise<EgiftPromotionsSection.IDiscount>;
        deletePromo(id: Guid, entity: { objectState: ObjectStateEnum }): angular.IPromise<void>;
        resendTransaction(request: { giftCardId: Guid, type: EgfitCommunicationTypeEnum }): angular.IPromise<{ status: number, value: boolean }>;
        getEmail(locationId: number): angular.IPromise<any>;
        updateTransaction(transaction: EgiftTransactionsSection.ITransaction): angular.IPromise<EgiftTransactionsSection.ITransaction>;
        addNote(request: EgiftTransactionsSection.INote, giftCardId: string): angular.IPromise<EgiftTransactionsSection.INote>;
        getGiftCardAudit(id: Guid, locationId: Guid): angular.IPromise<Array<EgiftTransactionsSection.IGiftCardAudit>>;
        getSettings(): angular.IPromise<IEGiftsSettings>;
        getBusinessSettings(): angular.IPromise<any>;
        getEmailTemplateByDeliveryMethod(deliveryMethod: DeliveryMethodEnum, itemType: NotificationItemTypeEnum, promoDeliveryMethod: DeliveryMethodEnum): angular.IPromise<Array<EgiftNotificationsSection.INotification>>;
        saveNotifications(templates): angular.IPromise<Array<EgiftNotificationsSection.INotification>>;
        getTemplateList(): angular.IPromise<ITemplateItem>;
        getImageUrl(storageTypeEnum: StorageTypeEnum, fileGuid: Guid | string): angular.IPromise<ITemplateItem>;
        getCustomBrandingImage(): angular.IPromise<ICustomBranding>;
        saveImageToStorage(file: IStorageFile): angular.IPromise<any>;
        getNotificationTemplate(communicationType: EgfitCommunicationTypeEnum): angular.IPromise<EgiftNotificationsSection.INotification>;
        //updateNote(note: EgiftTransactionsSection.INote, currentGcId: string): angular.IPromise<EgiftTransactionsSection.INote>;
        deleteNote(note: EgiftTransactionsSection.INote, currentGcId: string): angular.IPromise<EgiftTransactionsSection.INote>;
        getMerchantProviders(): angular.IPromise<MerchantProvider[]>;
        merchantAccountPreProcess(merchantAccounts: Array<MerchantAccount>, merchantProviders: Array<MerchantProvider>): Array<MerchantAccount>
        inactivatePromotion(id: any, objectState: ObjectStateEnum): angular.IPromise<any>
        resendShippingMain(data): angular.IPromise<boolean>
    }

    export class EgiftsService implements IEgiftsService {

        static $inject = [
            'meevo.components.common.DataService',
            'meevo.AppSettings',
            'meevo.components.tracking.TrackingService'
        ];

        constructor(
            public dataService: Meevo.Components.BaseClasses.IDataService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected trackingService: Meevo.Components.Tracking.ITrackingService
        ) { }

        getMerchantAccounts(request: EgiftMainSection.IGetMerchantAccountsReq): angular.IPromise<Array<MerchantAccount>> {
            return this.dataService.getListPaged(this.appSettings.API_ENDPOINTS.merchantAccount, request);
        }

        getLocation(locationId: number): angular.IPromise<EgiftMainSection.IEgiftLocationItem> {
          return this.dataService.getItem(`Location/${locationId}`);
        }
        
        updatePackages(packageList: Array<EgiftPackedgeSection.ISelectedPackage>): angular.IPromise<EgiftPackedgeSection.ISelectedPackage> {
            return this.dataService.patch('eGift/Packages', packageList);
        }
        
        updateServices(serviceList: Array<EgiftServicesSection.ISelectedService>): angular.IPromise<EgiftServicesSection.ISelectedService> {
            return this.dataService.patch('eGift/Services', serviceList);
        }
        // Todo: interface
        updateDiscounts(discountsList: EgiftPromotionsSection.ISelectedDiscounts): angular.IPromise<any> {
            return this.dataService.patch('eGift/Discounts', discountsList);
        }
        
        getTemplates(request: EgiftTemplates.IBaseTemplateReq, isCardTemplateSection: boolean): angular.IPromise<Array<ITemplateItem>> {
            let path = isCardTemplateSection ? '/MailPickup' : '';
            return this.dataService.getListPaged(`eGift/Template${path}`, request);
        }

        createTemplate(newTemplate: ITemplateItem, isCardTemplateSection: boolean): angular.IPromise<ITemplateItem> {
            let path = isCardTemplateSection ? '/MailPickup' : '';
            return this.dataService.patch(`eGift/Template${path}`, newTemplate);
        }

        updateTemplates(templatesList, templateType: EGiftTemplateType): angular.IPromise<void> {
            let path = templateType === EGiftTemplateType.CustomTemplate ? 'Custom' : templateType === EGiftTemplateType.GiftCardTemplate ? 'MailPickup' : 'System';
            return this.dataService.patch(`eGift/Template/${path}/List`, templatesList);
        }

        addNewPromo(promo: EgiftPromotionsSection.IEgiftDiscount): angular.IPromise<EgiftPromotionsSection.IDiscount> {
            return this.dataService.add(`${this.appSettings.API_ENDPOINTS.egifts}/${this.appSettings.API_ENDPOINTS.discount}`, promo);
        }

        editPromo(promo: EgiftPromotionsSection.IEgiftDiscount): angular.IPromise<EgiftPromotionsSection.IDiscount> {
            return this.dataService.update(`${this.appSettings.API_ENDPOINTS.egifts}/${this.appSettings.API_ENDPOINTS.discount}`, promo);
        }

        getPromo(id: Guid): angular.IPromise<EgiftPromotionsSection.IDiscount> {
            return this.dataService.getItem(`${this.appSettings.API_ENDPOINTS.egifts}/${this.appSettings.API_ENDPOINTS.discount}`, id);
        }

        deletePromo(id: Guid, entity: {objectState: ObjectStateEnum}): angular.IPromise<void> {
            return this.dataService.patch(`${this.appSettings.API_ENDPOINTS.egifts}/${this.appSettings.API_ENDPOINTS.discount}`, entity, id);
        }

        resendTransaction(request: { giftCardId: Guid, type: EgfitCommunicationTypeEnum }): angular.IPromise<{ status: number, value: boolean }> {
            return this.dataService.add('eGift/GiftCard/Resend', request);
        }
        // Todo: interface
        getEmail(locationId: number): angular.IPromise<any> {
            return this.dataService.add('Tenant/BusinessInfo/Location', { asLocationId: locationId });
        }
        
        updateTransaction(transaction: EgiftTransactionsSection.ITransaction): angular.IPromise<EgiftTransactionsSection.ITransaction> {
            return this.dataService.patch('eGift/GiftCard', transaction);
        }

        addNote(request: EgiftTransactionsSection.INote, giftCardId: string): angular.IPromise<EgiftTransactionsSection.INote> {
            return this.dataService.add(`eGift/GiftCard/${giftCardId}/Note`, request);
        }

        getGiftCardAudit(id: Guid, locationId: Guid): angular.IPromise<Array<EgiftTransactionsSection.IGiftCardAudit>> {
            return this.dataService.getItem(`eGift/GiftCard/${locationId}/${id}/Audit`);
        }

        getSettings(): angular.IPromise<IEGiftsSettings> {
            return this.dataService.getItem(`eGift/settings`);
        }
        // todo interface
        getBusinessSettings(): angular.IPromise<any> {
            return this.dataService.getItem(`Tenant/BusinessInfo/Settings`);
        }


        getEmailTemplateByDeliveryMethod(deliveryMethod: DeliveryMethodEnum, itemType: NotificationItemTypeEnum, promoDeliveryMethod: DeliveryMethodEnum): angular.IPromise<Array<EgiftNotificationsSection.INotification>> {
            return this.dataService.getItem(`eGift/notification/${deliveryMethod}/${itemType}/${promoDeliveryMethod}`);
        }

        saveNotifications(templates): angular.IPromise<Array<EgiftNotificationsSection.INotification>> {
            return this.dataService.add(`eGift/notification`, templates);
        }

        resendShippingMain(templates): angular.IPromise<boolean> {
            return this.dataService.customMethodData(`api/eGift/Mail/Resend`, 'POST', templates)
                .then(response => response)
        }

        /**
         * Get template list
         * @returns {angular.IPromise<ITemplateItem>}
         */

        getTemplateList(): angular.IPromise<ITemplateItem> {
            const request: EgiftMainSection.IGetTemplateListReq = {
                criteria: {
                    templateName: 'Default Template',
                    eGiftTemplateCategoryEnum: null,
                    eGiftTemplateTypeEnum: 30361,
                    isGiftCard: true
                }
            };
            return this.dataService.customMethodData(`api/eGift/Template/List`,'POST', request)
                .then(response => response.data);
        }

        /**
         * Get image url
         * @param {StorageTypeEnum} storageTypeEnum
         * @param {Guid | string} fileGuid
         * @returns {angular.IPromise<ITemplateItem>}
         */
         // todo interface
        public getImageUrl(storageTypeEnum: StorageTypeEnum, fileGuid: Guid | string): angular.IPromise<ITemplateItem> {
            return this.dataService.customMethodData(`/api/storage/customBrandingImage/${storageTypeEnum}/${fileGuid}`, 'GET', null)
                .then(response => response.data);
        }

        /**
         * Get Custom Branding default image
         * @returns {angular.IPromise<ICustomBranding>}
         */

        public getCustomBrandingImage(): angular.IPromise<ICustomBranding> {
            return this.dataService.customMethodData('api/settings/customBranding/', 'GET', null)
                .then(response => response.data);
        }

        /**
         * Get Custom Branding default image
         * @param {IStorageFile} file
         * @returns {angular.IPromise<any>}
         */
         // todo interface
        public saveImageToStorage(file: IStorageFile): angular.IPromise<any> {
            return this.dataService.customMethodData('/api/storage/customBrandingImage', 'POST', {
                customBrandingImageResource: _.extend(file, { resourceType: file.meevoFile['storageTypeEnum'] })
            });
        }

        /**
         * Get default notification template by Enum
         * @param {EgfitCommunicationTypeEnum} communicationType
         * @returns {angular.IPromise<any>}
         */
        getNotificationTemplate(communicationType: EgfitCommunicationTypeEnum): angular.IPromise<EgiftNotificationsSection.INotification> {
            return this.dataService.customMethodData(`api/eGift/SystemNotification`, 'GET', null, { communicationType } )
                .then(response => response.data);
        }

        ///**
        // * Update note by ID
        // * @param {INote} note
        // * @param {string} currentGcId
        // * @returns {angular.IPromise<EgiftTransactionsSection.INote>}
        // */

        //updateNote(note: EgiftTransactionsSection.INote, currentGcId: string): angular.IPromise<EgiftTransactionsSection.INote> {
        //    return this.dataService.update(`eGift/GiftCard/${currentGcId}/Note/${note.id}`, note);
        //}

        /**
         * Delete note by ID
         * @param {INote} note
         * @param {string} currentGcId
         * @returns {angular.IPromise<INote>}
         */

        deleteNote(note: EgiftTransactionsSection.INote, currentGcId: string): angular.IPromise<EgiftTransactionsSection.INote> {
            return this.dataService.deleteWithJsonBody(`eGift/GiftCard/${currentGcId}/Note/${note.id}`, note);
        }

        /**
         * Get arrays of merchant providers
         * @returns {angular.IPromise<MerchantProvider>} promise
         */
        getMerchantProviders(): angular.IPromise<MerchantProvider[]> {
            return this.dataService.getItem(`location/merchantProviders`);
        }

        /**
         * Preprocess received merchant accoumt via merchant providers
         * @param {Array<MerchantAccount>} merchantAccounts
         * @param {Array<MerchantProvider} merchantProviders
         * @returns {angular.IPromise<MerchantProvider>} promise
         */
        merchantAccountPreProcess(merchantAccounts: Array<MerchantAccount>, merchantProviders: Array<MerchantProvider>): Array<MerchantAccount> {
            const preprocessedData = merchantAccounts.slice();

            for (let index = preprocessedData.length - 1; index >= 0; index--) {
                const merchantAccount = preprocessedData[index];
                const merchantProvider = _(merchantProviders).find(provider => provider.id === merchantAccount.merchantProviderId);
                if (!merchantProvider || !merchantProvider.hasHostedPageSupport) {
                    preprocessedData.splice(index, 1);
                }
            }

            return preprocessedData;
        }

        /**
         * activate or inactivate promotion
         * @param {any} id
         * @param {ObjectStateEnum} objectState
         * @returns {angular.IPromise<any>} promise
         */
        inactivatePromotion(id: any, objectState: ObjectStateEnum): angular.IPromise<any> {
            return this.dataService.customMethodData('api/eGift/DiscountState/', 'Patch', {id, objectState});
        }

        getActivePromoGiftCards(): angular.IPromise<Array<GiftCardType>> {
            let request = {
                criteria: {
                    includeInvalid: false,
                    isPromo: true
                }
            }
            return this.dataService.getListPaged(this.appSettings.API_ENDPOINTS.giftCardType, request);
        }
    }

    angular.module('meevo.plugins.egifts')
        .service('meevo.plugins.egifts.egiftsService', EgiftsService);
}
